import * as MD from "@material-ui/core/";
import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { IApplicationState } from "../../Store";
import { ILayoutState } from "../../Store/Layout/Types";
import { I18N, ILocaleInfos } from "../../Store/I18n/Types";
import ClearIcon from "@material-ui/icons/Clear";

import {
  IDashboardState,
  IDateType,
  IDisplayFormat,
} from "../../Store/Dashboard/Types";
import {
  initialAutocompletePerson,
  ISearchState,
} from "../../Store/Search/Types";

import {
  clearPersonsList,
  getAutocompletePerson,
} from "../../Store/Search/Actions";
import { IAutocompletePerson } from "../../Store/Search/Types";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { PeriodSelection, PeriodSelectionComponent } from "../PeriodSelection";
import { isNullOrUndefined } from "../../Utils/Various";
import {
  getPlayerRapidSearch,
  getPlayerPoliticalGroups,
  getPlayerPersons,
  getPlayerAdvancedSearch,
  getAutocompleteEmission,
  getEmissionSearch,
  clearEmissionList,
} from "../../Store/Player/Actions";
import { DrawSelect } from "./DrawSelect";
import {
  IEmissionSearchFilters,
  IPlayerGroups,
  IPlayerRapidSearchFilters,
  IPlayerState,
  IAdvancedSearchPlayerFilters,
  playerPoliticalGroupsFilters,
  playerPoliticalPersonFilters,
} from "../../Store/Player/Types";
import { hideDrawer, showDrawer } from "../../Store/Layout/Actions";
import { IUserState } from "../../Store/User/Types";
import { ElectionSelect } from "./ElectionSelect";
import {
  IElectionsState,
  PRESIDENTIEL_ELECTION,
} from "../../Store/Elections/Types";
import { getCurrentEtude } from "../../Store/Elections/Reducer";
import {
  adjustForTimezone,
  getDateHourZero,
  minMaxDates,
} from "../../Utils/Time";
interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
  player: IPlayerState;
  user: IUserState;
  dashboard: IDashboardState;
  elections: IElectionsState;
}

interface InitialState {
  openError: boolean;
  errorMessage: string;
  open: boolean;
  startDate: Date;
  endDate: Date;
  startSlot: Date;
  endSlot: Date;
  timeStart: string;
  timeEnd: string;
  selectedYear: number;
  dateType: IDateType;
  // groups state
  playerGroups: IPlayerGroups[];
  groupsID: number[];
  groupsStr: string[];
  isAllGroupsSelected: boolean;
  // persons state
  personsPlayer: IPlayerGroups[];
  personsID: number[];
  personsStr: string[];
  isAllPersonsSelected: boolean;
  electionsID: number;
  electionsIDArray: number[];
  // medias state
  mediasID: number[] | null;
  mediasStr: string[];
  isAllMediasSelected: boolean;
  // program types state
  programTypesID: number[] | null;
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  // program editors state
  programEditorsID: number[];
  programEditorStr: string[];
  isAllProgramEditorsSelected: boolean;
  //datePicker
  isFullYearSelected: boolean;
  isSem1Activated: boolean;
  isSem2Activated: boolean;
  isTrim1Selected: boolean;
  isTrim2Selected: boolean;
  isTrim3Selected: boolean;
  isTrim4Selected: boolean;
  selectedMonthIndex: any;
  displayFormat: IDisplayFormat;
  openPanelIndex: number;
  selectedPanel: any;
  person: IAutocompletePerson | null;
  personList: IAutocompletePerson[] | null;
  persons: string[];
  emission: string;
  emissions: string[] | null;
}

interface IOwnState {}

interface IPropsFromDispatch {
  hideDrawer: typeof hideDrawer;
  showDrawer: typeof showDrawer;
  getAutocompletePerson: typeof getAutocompletePerson;
  getAutocompleteEmission: typeof getAutocompleteEmission;
  getPlayerRapidSearch: typeof getPlayerRapidSearch;
  getPlayerGroups: typeof getPlayerPoliticalGroups;
  getPlayerPersons: typeof getPlayerPersons;
  getPlayerAdvancedSearch: typeof getPlayerAdvancedSearch;
  getEmissionSearch: typeof getEmissionSearch;
  clearPersonsList: typeof clearPersonsList;
  clearEmissionList: typeof clearEmissionList;
}

interface ISearchProps {}

type IAppState = InitialState & IOwnState;

type AllProps = MD.WithTheme &
  MD.WithStyles &
  IPropsFromState &
  IPropsFromDispatch &
  ISearchProps;

const styles = (theme: any) =>
  MD.createStyles({
    container: {
      display: "grid",
      position: "absolute",
      width: "100%",
      left: "0px",
    },
    titleButton: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid",
      fontSize: "14px",
      textTransform: "none",
      borderColor: "gray",
    },
    panel: {
      padding: "10px",
      width: "296px",
    },
    inputLabel: {
      fontSize: "smaller",
      marginTop: "-2px",
    },
    form: {
      marginTop: "-5px",
      display: "flex",
      flexFlow: "row",
      flexWrap: "wrap",
    },
    formControl: {
      width: "100%",
      marginTop: "12px",
    },
    focused: {},
    searchButton: {
      fontSize: 13,
      paddingTop: "0px",
      paddingBottom: "0px",
      margin: "10px 85px 0px 85px",
      backgroundColor: theme.palette.secondary.main,
    },
    inputStyle: {
      width: "100%",
      padding: "5px",
      fontSize: "12px",
      border: "1px gray",
    },
    drawerPaper: {
      width: "300px",
      padding: "40px 15px 0px 15px",
      overflowX: "hidden",
      backgroundColor: theme.palette.background.default,
      border: "2px solid " + theme.palette.background.paper,
    },
    drawer: {
      "&.hidden": {
        width: "0px",
      },
      flexShrink: 0,
    },
  });

const initialState: InitialState = {
  openError: false,
  errorMessage: "",
  open: true,
  selectedYear: -1,
  dateType: "calendar",
  startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  endDate: new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  ),
  startSlot: new Date(0),
  endSlot: new Date(0),
  timeStart: "00:00",
  timeEnd: "00:00",
  playerGroups: [],
  groupsID: [],
  groupsStr: [""],
  isAllGroupsSelected: false,
  personsPlayer: [],
  personsID: [],
  personsStr: ["TOUS"],
  isAllPersonsSelected: true,
  programEditorsID: [],
  programEditorStr: [],
  isAllProgramEditorsSelected: false,
  isSem1Activated: false,
  isSem2Activated: false,
  isFullYearSelected: false,
  isTrim1Selected: false,
  isTrim2Selected: false,
  isTrim3Selected: false,
  isTrim4Selected: false,
  selectedMonthIndex: null,
  displayFormat: "duration",
  openPanelIndex: 0,
  selectedPanel: null,
  person: initialAutocompletePerson,
  emission: "",
  personList: null,
  persons: [],
  electionsID: 24,
  electionsIDArray: [],
  // medias state
  mediasID: null,
  mediasStr: [],
  isAllMediasSelected: true,
  // programTypes state
  programTypesID: null,
  programTypesStr: [],
  isAllProgramTypesSelected: true,
  emissions: null,
};

type DialogAllProps = MD.WithStyles<typeof styles> & MD.WithTheme;

export interface DialogTitleProps extends DialogAllProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

export class PlayerDrawerComponent extends React.Component<
  AllProps,
  IAppState
> {
  private PeriodRef: React.RefObject<PeriodSelectionComponent>;

  public constructor(props: AllProps) {
    super(props);

    this.PeriodRef = React.createRef<PeriodSelectionComponent>();

    this.state = {
      ...initialState,
    };
  }

  static getDerivedStateFromProps(props: AllProps, state: IAppState) {
    if (props.dashboard.dateCloture !== null && state.selectedYear === -1) {
      let endDate = props.dashboard.dateCloture;
      state.selectedYear = endDate.getFullYear();
      state.startDate = new Date(
        endDate.getFullYear(),
        endDate.getUTCMonth(),
        1
      );
      state.endDate = endDate;
    }

    if (!props.elections.isElectionChecked) {
      state.electionsID = 24;
    }
    if (
      props.elections.elections_study_types &&
      props.elections.elections_study_types.length > 0 &&
      state.selectedPanel === null
    ) {
      let elections = [...props.elections.elections_study_types];
      if (props.elections.isElectionChecked) {
        elections = elections.filter(
          (x) => x.id >= PRESIDENTIEL_ELECTION.FIRST_ROUND
        );
        state.electionsID = getCurrentEtude(elections).id;
        if (props.elections.elections_start_date !== null) {
          let endDate = minMaxDates([
            props.elections.elections_end_date,
            props.dashboard.dateCloture,
          ]).minDate;
          let startDate = minMaxDates([
            props.elections.elections_start_date,
            endDate,
          ]).minDate;
          startDate = adjustForTimezone(startDate);
          state.selectedPanel = 0;
          let newDate: Date = new Date(
            new Date(endDate).setDate(endDate.getDate() + 1)
          );
          state.endDate = getDateHourZero(newDate);
          state.startDate = getDateHourZero(startDate);
        }
      }
      state.electionsIDArray = elections.map((x) => x.id);
    }
    if (state.playerGroups !== props.player.playerGroups) {
      state.playerGroups = props.player.playerGroups;
      if (props.player.playerGroups.length > 0) {
        state.isAllGroupsSelected = true;
        state.isAllPersonsSelected = true;
        state.groupsStr = ["TOUS"];
      } else {
        state.isAllGroupsSelected = false;
        state.isAllPersonsSelected = false;
        state.groupsStr = [""];
      }
    }
    if (
      JSON.stringify(state.personsPlayer) !==
      JSON.stringify(props.player.playerPersons)
    ) {
      state.personsPlayer = props.player.playerPersons;
      state.personsID = props.player.initialPlayerPersonsID;
      state.personsStr = props.player.initialPlayerPersonsStr;
      if (state.personsID.length > 0) {
        state.isAllPersonsSelected = true;
      } else {
        state.isAllPersonsSelected = false;
        state.personsID = [];
        state.personsStr = [];
      }
    }
    if (
      JSON.stringify(state.personList) !==
      JSON.stringify(props.search.autocompletePersonList)
    ) {
      state.personList = props.search.autocompletePersonList;
    }
    if (
      props.search.allProgramTypesID.length > 0 &&
      state.programTypesID === null
    ) {
      state.programTypesID = props.search.allProgramTypesID;
      state.programTypesStr = props.search.allProgramTypesSTR;
    }
    if (props.user.allMediasID.length > 0 && state.mediasID === null) {
      state.mediasID = props.user.allMediasID;
      state.mediasStr = props.user.allMediasSTR;
    }
    if (
      JSON.stringify(state.emissions) !== JSON.stringify(props.player.emissions)
    ) {
      state.emissions = props.player.emissions;
    }
    return state;
  }

  componentDidUpdate(prevProps: AllProps, prevState: IAppState) {}

  private openPanel(index: number) {
    if (this.props.dashboard.dateCloture !== null) {
      this.setState(
        {
          openPanelIndex: index,
          mediasID: this.props.user.allMediasID,
          mediasStr: this.props.user.allMediasSTR,
          isAllMediasSelected: true,
          startDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          ),
          endDate: this.props.dashboard.dateCloture,
          selectedPanel: null,
        },
        () => {
          if (index === 2) {
            this.getPlayerGroups(this.state.startDate, this.state.endDate);
          }
        }
      );
    }
  }

  private onNameChange(e: any) {
    let search_input = e.currentTarget.value;
    let stateCopy = { ...this.state };
    let personCopy = { ...stateCopy.person } as IAutocompletePerson;
    this.setState({
      person: {
        ...personCopy,
        last_name: search_input,
      },
    });
    if (search_input !== undefined && search_input.length > 1) {
      this.props.getAutocompletePerson(search_input);
    }
  }
  private onEmissionChange(e: any) {
    let search_input = e.currentTarget.value;
    this.setState({ emission: search_input });
    if (search_input !== undefined && search_input.length > 1) {
      // Toujours utiliser le nouvel endpoint avec les media_ids sélectionnés
      // Si tous les médias sont sélectionnés, utiliser tous les IDs des médias
      const mediaIds = this.state.isAllMediasSelected
        ? this.props.user.allMediasID
        : this.state.mediasID && this.state.mediasID.length > 0
        ? this.state.mediasID
        : this.props.user.allMediasID;
      this.props.getAutocompleteEmission(search_input, mediaIds);
    }
  }
  private setPersonAutocompleteValue(event: any, newValue: any) {
    this.setState({
      person: newValue,
    });
    if (newValue === null) {
      this.setState({
        person: {
          ...initialAutocompletePerson,
          first_name: null,
        },
      });
      this.props.clearPersonsList();
    }
  }
  private setEmissionAutocompleteValue(event: any, newValue: any) {
    this.setState({
      emission: newValue,
    });
    if (newValue === "") {
      this.props.clearEmissionList();
    }
  }
  private saveDates(
    startDate: Date,
    endDate: Date,
    startSlot: Date,
    endSlot: Date,
    dateType: IDateType
  ) {
    this.setState({
      startDate: startDate,
      endDate: endDate,
      startSlot: startSlot,
      endSlot: endSlot,
      dateType: dateType,
    });
  }
  private getPlayerGroups(startDate: Date, endDate: Date) {
    let timeStartArray: string[] = startDate.toTimeString().split(" ");
    let timeStart = "";
    if (timeStartArray !== undefined) {
      timeStart = timeStartArray[0].substring(0, 5);
    }
    let timeEndArray: string[] = endDate.toTimeString().split(" ");
    let timeEnd = "";
    if (timeEndArray !== undefined) {
      timeEnd = timeEndArray[0].substring(0, 5);
    }
    this.setState(
      {
        timeStart,
        timeEnd,
      },
      () => {
        if (this.state.mediasID !== null) {
          this.props.getPlayerGroups({
            media_ids: this.state.mediasID,
            start_date: startDate,
            end_date: endDate,
            time_slot_end: timeEnd,
            time_slot_start: timeStart,
          });
          this.props.getPlayerPersons({
            media_ids: this.state.mediasID,
            date_start: this.state.startDate,
            date_end: this.state.endDate,
            time_slot_start: this.state.timeStart,
            time_slot_end: this.state.timeEnd,
          });
        }
      }
    );
  }
  private onSearch() {
    if (
      this.state.openPanelIndex === 0 &&
      this.state.person !== null &&
      this.state.mediasID !== null &&
      this.props.search.allProgramEditorsID !== null
    ) {
      this.props.getPlayerRapidSearch({
        media_ids: this.state.mediasID,
        media_str: this.props.user.allMediasSTR,
        program_type_ids: this.props.search.allProgramTypesID,
        program_type_str: this.props.search.allProgramTypesSTR,
        program_editor_ids: this.props.search.allProgramEditorsID,
        program_editor_str: this.props.search.allProgramEditorsSTR,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        person_name: this.state.person.last_name,
        isAllMediaSelected: true,
        isAllProgramEditorsSelected: true,
        isAllProgramTypesSelected: true,
        study_type_id: this.state.electionsID,
      });
    }
    if (
      this.state.openPanelIndex === 1 &&
      this.state.mediasID !== null &&
      this.state.emission !== null &&
      this.props.search.allProgramEditorsID !== null
    ) {
      this.props.getEmissionSearch(
        {
          date_start: this.state.startDate,
          date_end: this.state.endDate,
          program_editor_ids: this.props.search.allProgramEditorsID,
          program_type_ids: this.props.search.allProgramTypesID,
          media_ids: this.state.mediasID,
          media_str: this.props.user.allMediasSTR,
          program_type_str: this.props.search.allProgramTypesSTR,
          program_editor_str: this.props.search.allProgramEditorsSTR,
          emission_name: this.state.emission,
          isAllMediaSelected: true,
          isAllProgramEditorsSelected: true,
          isAllProgramTypesSelected: true,
          study_type_id: this.state.electionsID,
        },
        this.state.emission
      );
    }
    if (
      this.state.openPanelIndex === 2 &&
      this.state.mediasID !== null &&
      this.props.search.allProgramEditorsID !== null
    ) {
      let filters: IAdvancedSearchPlayerFilters = {
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        time_slot_start: this.state.timeStart,
        time_slot_end: this.state.timeEnd,
        program_editor_ids: this.props.search.allProgramEditorsID,
        program_type_ids: this.props.search.allProgramTypesID,
        media_ids: this.state.mediasID,
        media_str: this.props.user.allMediasSTR,
        program_type_str: this.props.search.allProgramTypesSTR,
        program_editor_str: this.props.search.allProgramEditorsSTR,
        isAllMediaSelected: true,
        isAllProgramEditorsSelected: true,
        isAllProgramTypesSelected: true,
        study_type_id: this.state.electionsID,
      };
      if (this.state.groupsID.length === 1) {
        filters.political_group_id = this.state.groupsID[0];
        filters.political_group_name = this.state.groupsStr[0];
      }
      if (
        this.state.personsID.length === 1 &&
        !this.state.isAllPersonsSelected
      ) {
        filters.person_id = this.state.personsID[0];
        filters.person_name = this.state.personsStr[0];
      }
      this.props.getPlayerAdvancedSearch(filters);
    }
    this.props.hideDrawer();
  }
  private buildSearchButton() {
    return (
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <MD.FormControl className={this.props.classes.formControl}>
          <MD.Button
            className={this.props.classes.searchButton}
            color="secondary"
            onClick={() => {
              this.onSearch();
            }}
            variant="contained"
          >
            {this.props.i18n._("Search")}
          </MD.Button>
        </MD.FormControl>
      </div>
    );
  }
  private buildRechercheRapide() {
    const { classes, i18n, ...other } = this.props;
    return (
      <div className={classes.panel}>
        <div
          id="autocomplete-panel"
          style={{ display: "inline-flex", width: "100%" }}
        >
          <MD.Typography
            style={{
              width: "25%",
              textAlign: "center",
              fontSize: "13px",
              padding: "9px",
            }}
          >
            {i18n._("Name")}
          </MD.Typography>
          <Autocomplete
            style={{ width: "75%" }}
            id="autocomplete"
            //freeSolo
            value={this.state.person}
            loadingText={<MD.CircularProgress color="primary" size={20} />}
            loading={this.props.search.isPersonAutocompleteLoading}
            options={
              this.state.personList === null
                ? [initialAutocompletePerson]
                : this.state.personList
            }
            getOptionSelected={(option, value) => {
              if (value.last_name === "") {
                return true;
              } else if (value === option) {
                return true;
              }
              return true;
            }}
            renderOption={(option: IAutocompletePerson) => {
              return <div style={{ fontSize: "12px" }}>{option.last_name}</div>;
            }}
            getOptionLabel={(option) =>
              option.last_name ? option.last_name : ""
            }
            noOptionsText={i18n._("No options")}
            onChange={this.setPersonAutocompleteValue.bind(this)}
            renderInput={(params) => (
              <MD.TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  className: classes.inputStyle,
                  endAdornment: (
                    <React.Fragment>
                      <MD.InputAdornment position="end">
                        <MD.IconButton
                          aria-label="clear"
                          onClick={(e: any) =>
                            this.setPersonAutocompleteValue(e, null)
                          }
                          edge="end"
                        >
                          {(this.state.person !== null &&
                            this.state.person.last_name.length > 1) ||
                          (this.state.personList !== null &&
                            this.state.personList.length > 0) ? (
                            <React.Fragment>
                              <MD.Divider orientation="vertical" flexItem />
                              <ClearIcon color="primary" />
                            </React.Fragment>
                          ) : null}
                        </MD.IconButton>
                      </MD.InputAdornment>
                    </React.Fragment>
                  ),
                }}
                label=""
                variant="outlined"
                onChange={this.onNameChange.bind(this)}
              />
            )}
          />
        </div>
        <div style={{ marginRight: "-10px", paddingBottom: "20px" }}>
          {this.state.mediasID !== null && (
            <DrawSelect
              i18n={i18n}
              title={i18n._("Medias")}
              list={this.props.user.medias}
              listID={this.state.mediasID}
              listStr={this.state.mediasStr}
              allListIDs={this.props.user.allMediasID}
              allListStr={this.props.user.allMediasSTR}
              isAllSelected={this.state.isAllMediasSelected}
              saveChanges={this.saveMediasChanges.bind(this)}
              multiple={true}
            />
          )}
          {this.props.elections.isElectionChecked &&
            this.state.electionsIDArray.length > 0 && (
              <ElectionSelect
                {...other}
                handleElectionChange={this.handleElectionChange.bind(this)}
                electionsID={this.state.electionsID}
                electionsIDArray={this.state.electionsIDArray}
              />
            )}
        </div>
        <PeriodSelection
          ref={this.PeriodRef}
          saveDates={this.saveDates.bind(this)}
          hideGroupCalendar={false}
          hideCalendar={true}
          hideTime={true}
        />
        {this.buildSearchButton()}
      </div>
    );
  }
  // --------------> groups update
  private updateGroups(id: number, name: string) {
    let newState = { ...this.state };
    newState.groupsID = [id];
    newState.groupsStr = [name];
    if (this.state.mediasID !== null) {
      this.props.getPlayerPersons({
        media_ids: this.state.mediasID,
        date_start: this.state.startDate,
        date_end: this.state.endDate,
        time_slot_start: this.state.timeStart,
        time_slot_end: this.state.timeEnd,
        political_group_id: id,
      });
    }

    this.setState({
      ...newState,
      isAllGroupsSelected: false,
    });
  }
  private handleAllGroups() {
    this.setState({
      groupsID: this.props.player.initialPlayerGroupsID,
      groupsStr: this.props.player.initialPlayerGroupsStr,
      isAllGroupsSelected: true,
      personsID: this.props.player.initialPlayerPersonsID,
      personsStr: this.props.player.initialPlayerPersonsStr,
      isAllPersonsSelected: true,
    });
    this.state.mediasID !== null &&
      this.props.getPlayerPersons({
        media_ids: this.state.mediasID,
        date_start: this.state.startDate,
        date_end: this.state.endDate,
        time_slot_start: this.state.timeStart,
        time_slot_end: this.state.timeEnd,
      });
  }
  // --------------> persons update
  private updatePersons(id: number, name: string) {
    let newState = { ...this.state };
    newState.personsID = [id];
    newState.personsStr = [name];
    this.setState({
      ...newState,
      isAllPersonsSelected: false,
    });
  }
  private handleAllPersons() {
    this.setState({
      personsID: this.props.player.initialPlayerPersonsID,
      personsStr: this.props.player.initialPlayerPersonsStr,
      isAllPersonsSelected: true,
    });
  }

  private buildListPoliticalGroup() {
    const { i18n } = this.props;
    return (
      <div style={{ marginTop: 10 }}>
        <DrawSelect
          i18n={i18n}
          title={i18n._("Groups")}
          list={this.state.playerGroups}
          listID={this.state.groupsID}
          listStr={this.state.groupsStr}
          isAllSelected={this.state.isAllGroupsSelected}
          allListIDs={this.props.player.initialPlayerPersonsID}
          allListStr={this.props.player.initialPlayerPersonsStr}
          updateList={this.updateGroups.bind(this)}
          handleAllList={this.handleAllGroups.bind(this)}
          multiple={false}
        />
      </div>
    );
  }
  private buildPersonsList() {
    const { i18n } = this.props;
    return (
      <DrawSelect
        i18n={i18n}
        title={i18n._("Persons")}
        list={this.state.personsPlayer}
        listID={this.state.personsID}
        listStr={this.state.personsStr}
        isAllSelected={this.state.isAllPersonsSelected}
        allListIDs={this.props.player.initialPlayerPersonsID}
        allListStr={this.props.player.initialPlayerPersonsStr}
        updateList={this.updatePersons.bind(this)}
        handleAllList={this.handleAllPersons.bind(this)}
        multiple={false}
      />
    );
  }
  private handleElectionChange(e: any) {
    let value = e.target.value;

    let elections: any = [...this.props.elections.elections_study_types];
    elections = elections.filter((x) => x.id === value)[0];
    let endDate = new Date(elections.end);
    if (this.props.dashboard.dateCloture !== null) {
      endDate = minMaxDates([
        new Date(elections.end),
        this.props.dashboard.dateCloture,
      ]).minDate;
    }
    let startDate = minMaxDates([new Date(elections.start), endDate]).minDate;
    startDate = adjustForTimezone(startDate);
    let newDate: Date = new Date(
      new Date(endDate).setDate(endDate.getDate() + 1)
    );
    endDate = getDateHourZero(newDate);
    startDate = getDateHourZero(startDate);
    this.setState({
      electionsID: e.target.value,
      electionsIDArray: [value],
      startDate,
      endDate,
    });
  }
  private saveMediasChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      mediasID: ids,
      mediasStr: str,
      isAllMediasSelected: bool,
    });
  }
  private buildAdvancedSearch() {
    const { classes, i18n, ...other } = this.props;
    return (
      <div className={classes.panel}>
        {this.state.mediasID !== null && (
          <DrawSelect
            i18n={i18n}
            title={i18n._("Medias")}
            list={this.props.user.medias}
            listID={this.state.mediasID}
            listStr={this.state.mediasStr}
            allListIDs={this.props.user.allMediasID}
            allListStr={this.props.user.allMediasSTR}
            isAllSelected={this.state.isAllMediasSelected}
            saveChanges={this.saveMediasChanges.bind(this)}
            multiple={true}
          />
        )}
        {this.props.elections.isElectionChecked &&
          this.state.electionsIDArray.length > 0 && (
            <ElectionSelect
              {...other}
              handleElectionChange={this.handleElectionChange.bind(this)}
              electionsID={this.state.electionsID}
              electionsIDArray={this.state.electionsIDArray}
            />
          )}
        <PeriodSelection
          ref={this.PeriodRef}
          getPlayerGroups={this.getPlayerGroups.bind(this)}
          saveDates={this.saveDates.bind(this)}
          hideGroupCalendar={true}
          hideCalendar={false}
          hideTime={false}
        />
        {this.props.player.isPlayerGroupsLoading ? (
          <MD.CircularProgress size={20} color="primary" />
        ) : (
          this.buildListPoliticalGroup()
        )}
        {this.props.player.isPlayerPersonsLoading ? (
          <MD.CircularProgress size={20} color="primary" />
        ) : (
          this.buildPersonsList()
        )}
        {this.buildSearchButton()}
      </div>
    );
  }
  private buildRechercheEmission() {
    const { classes, i18n, ...other } = this.props;
    return (
      <div className={classes.panel}>
        <div
          id="autocomplete-panel"
          style={{ display: "inline-flex", width: "100%" }}
        >
          <MD.Typography
            style={{
              width: "25%",
              textAlign: "center",
              fontSize: "13px",
              padding: "9px",
            }}
          >
            {i18n._("Show")}
          </MD.Typography>
          <Autocomplete
            style={{ width: "75%" }}
            id="autocomplete"
            //freeSolo
            value={this.state.emission}
            loadingText={<MD.CircularProgress color="primary" size={20} />}
            loading={this.props.player.isEmissionAutocompleteLoading}
            options={this.state.emissions === null ? [] : this.state.emissions}
            getOptionSelected={(option, value) => {
              if (value === "") {
                return true;
              } else if (value === option) {
                return true;
              }
              return true;
            }}
            renderOption={(option) => {
              return <div style={{ fontSize: "12px" }}>{option}</div>;
            }}
            getOptionLabel={(option) => option}
            noOptionsText={i18n._("No options")}
            onChange={this.setEmissionAutocompleteValue.bind(this)}
            renderInput={(params) => (
              <MD.TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  className: classes.inputStyle,
                  endAdornment: (
                    <React.Fragment>
                      <MD.InputAdornment position="end">
                        <MD.IconButton
                          aria-label="clear"
                          onClick={(e: any) =>
                            this.setEmissionAutocompleteValue(e, "")
                          }
                          edge="end"
                        >
                          {(this.state.emission !== null &&
                            this.state.emission.length > 1) ||
                          (this.state.emissions !== null &&
                            this.state.emissions.length > 0) ? (
                            <React.Fragment>
                              <MD.Divider orientation="vertical" flexItem />
                              <ClearIcon color="primary" />
                            </React.Fragment>
                          ) : null}
                        </MD.IconButton>
                      </MD.InputAdornment>
                    </React.Fragment>
                  ),
                }}
                value={this.state.emission}
                label=""
                variant="outlined"
                onChange={this.onEmissionChange.bind(this)}
              />
            )}
          />
        </div>
        <div style={{ marginRight: "-10px", paddingBottom: "20px" }}>
          {this.state.mediasID !== null && (
            <DrawSelect
              i18n={i18n}
              title={i18n._("Medias")}
              list={this.props.user.medias}
              listID={this.state.mediasID}
              listStr={this.state.mediasStr}
              allListIDs={this.props.user.allMediasID}
              allListStr={this.props.user.allMediasSTR}
              isAllSelected={this.state.isAllMediasSelected}
              saveChanges={this.saveMediasChanges.bind(this)}
              multiple={true}
            />
          )}
          {this.props.elections.isElectionChecked &&
            this.state.electionsIDArray.length > 0 && (
              <ElectionSelect
                {...other}
                handleElectionChange={this.handleElectionChange.bind(this)}
                electionsID={this.state.electionsID}
                electionsIDArray={this.state.electionsIDArray}
              />
            )}
        </div>
        <PeriodSelection
          ref={this.PeriodRef}
          saveDates={this.saveDates.bind(this)}
          hideGroupCalendar={false}
          hideCalendar={true}
          hideTime={true}
        />
        {this.buildSearchButton()}
      </div>
    );
  }

  componentWillUnmount() {
    this.props.showDrawer();
  }
  public render(): React.ReactNode {
    const { classes, i18n, layout, theme } = this.props;

    return (
      <MD.Drawer
        anchor="left"
        classes={{ paper: classes.drawerPaper }}
        className={
          classes.drawer +
          (!isNullOrUndefined(layout.drawerContent) && layout.showDrawer
            ? ""
            : "hidden")
        }
        open={layout.showDrawer}
        variant="persistent"
      >
        <div id="button-panels" className={classes.container}>
          <MD.Button
            onClick={() => this.openPanel(0)}
            className={classes.titleButton}
            style={{
              backgroundColor:
                this.state.openPanelIndex === 0
                  ? theme.palette.secondary.main
                  : undefined,
              color: this.state.openPanelIndex === 0 ? "white" : undefined,
            }}
          >
            {i18n._("Search / person")}
          </MD.Button>
          {this.state.openPanelIndex === 0 && this.buildRechercheRapide()}
          <MD.Button
            onClick={() => this.openPanel(1)}
            className={classes.titleButton}
            style={{
              backgroundColor:
                this.state.openPanelIndex === 1
                  ? theme.palette.secondary.main
                  : undefined,
              color: this.state.openPanelIndex === 1 ? "white" : undefined,
            }}
          >
            {i18n._("Search / show")}
          </MD.Button>
          {this.state.openPanelIndex === 1 && this.buildRechercheEmission()}
          {!this.props.elections.isElectionChecked && (
            <MD.Button
              onClick={() => this.openPanel(2)}
              className={classes.titleButton}
              style={{
                backgroundColor:
                  this.state.openPanelIndex === 2
                    ? theme.palette.secondary.main
                    : undefined,
                color: this.state.openPanelIndex === 2 ? "white" : undefined,
              }}
            >
              {i18n._("Advanced search")}
            </MD.Button>
          )}
          {!this.props.elections.isElectionChecked &&
            this.state.openPanelIndex === 2 &&
            this.buildAdvancedSearch()}
        </div>
      </MD.Drawer>
    );
  }
}
const mapStateToProps = ({
  layout,
  i18n,
  ui,
  search,
  player,
  user,
  dashboard,
  elections,
}: IApplicationState) => ({
  layout,
  localeInfos: i18n.localeInfos,
  i18n: i18n.i18n,
  ui,
  search,
  player,
  user,
  dashboard,
  elections,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  hideDrawer: () => dispatch(hideDrawer()),
  showDrawer: () => dispatch(showDrawer()),
  getAutocompletePerson: (personName: string) =>
    dispatch(getAutocompletePerson(personName)),
  getAutocompleteEmission: (emission: string, media_ids?: number[]) =>
    dispatch(getAutocompleteEmission(emission, media_ids)),
  getPlayerRapidSearch: (filters: IPlayerRapidSearchFilters) =>
    dispatch(getPlayerRapidSearch(filters)),
  getPlayerGroups: (filters: playerPoliticalGroupsFilters) =>
    dispatch(getPlayerPoliticalGroups(filters)),
  getPlayerPersons: (filters: playerPoliticalPersonFilters) =>
    dispatch(getPlayerPersons(filters)),
  getPlayerAdvancedSearch: (filters: IAdvancedSearchPlayerFilters) =>
    dispatch(getPlayerAdvancedSearch(filters)),
  getEmissionSearch: (filters: IEmissionSearchFilters, emission_name: string) =>
    dispatch(getEmissionSearch(filters, emission_name)),
  clearPersonsList: () => dispatch(clearPersonsList()),
  clearEmissionList: () => dispatch(clearEmissionList()),
});

export const PlayerDrawer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(PlayerDrawerComponent)));
